import moment from 'moment';

export const millisecondsToMinutes = (input: number): string => {
  const duration = moment.duration(input);
  const minutes = Math.floor(duration.asMinutes());
  const seconds = duration.seconds().toString().padStart(2, '0');
  return `${minutes}:${seconds}`;
};

export const millisecondsToMinutesDecimal = (input: number): number =>
  Math.round(moment.duration(input).asMinutes() * 100) / 100;
